import { Link } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Shared public-site header.
 * Pass `active` as one of: 'home' | 'travel' | 'reserve' | 'scholarship'
 */
const SiteHeader = ({ active = 'home' }) => {
  const linkBase = 'font-medium transition-colors text-sm';
  const activeCls =
    'text-gray-900 font-semibold relative after:absolute after:left-0 after:right-0 after:-bottom-1 after:h-0.5 after:bg-gradient-to-r after:from-wine after:to-burgundy';
  const idleCls = 'text-gray-500 hover:text-gray-900';

  return (
    <header
      className="bg-white/95 backdrop-blur-md border-b border-gray-100 py-4 px-4 md:px-6 sticky top-0 z-50"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between flex-wrap gap-3">
        <Link to="/" className="flex items-center gap-2" data-testid="site-header-logo">
          <span className="font-display text-2xl md:text-3xl font-semibold tracking-tight bg-gradient-to-br from-wine to-burgundy bg-clip-text text-transparent">
            ROJO
          </span>
          <span className="hidden sm:inline text-[10px] eyebrow text-gray-400 border-l border-gray-200 pl-2">
            Mens Retreat 2027
          </span>
        </Link>
        <div className="flex items-center gap-3 md:gap-6">
          <nav className="flex gap-4 md:gap-6">
            <Link
              to="/"
              className={`${linkBase} ${active === 'home' ? activeCls : idleCls}`}
              data-testid="nav-home"
            >
              Home
            </Link>
            <Link
              to="/travel"
              className={`${linkBase} ${active === 'travel' ? activeCls : idleCls}`}
              data-testid="nav-travel"
            >
              Travel
            </Link>
            <Link
              to="/scholarship"
              className={`${linkBase} ${active === 'scholarship' ? activeCls : idleCls}`}
              data-testid="nav-scholarship"
            >
              Scholarship
            </Link>
          </nav>
          <Link to="/login" data-testid="header-login-btn">
            <Button
              variant="outline"
              size="sm"
              className="border-gray-200 text-gray-700 hover:bg-gray-50 hover:border-gray-300 font-medium text-xs md:text-sm px-3 md:px-4 btn-lift"
            >
              <LogIn className="w-3.5 h-3.5 mr-1.5" />
              Sign In
            </Button>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default SiteHeader;
